import styled from 'styled-components';  
import Img1 from '../../../img/vol2.jpg';
const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`

const Vol2: React.VFC = () => {
  return (
    <Main>
<div className="text-break Blog-comment">
                <p>今回のレッスンテーマは『重心』。</p>
                <p>すべての物には重心という重さの中心があることを学習しました。ものさしのように太さがどこでも同じ物の重心は真ん中にあることや、バットのように片側が太くなっている物の重心は真ん中よりも太い側に寄った位置にあることは、みんな感覚的にわかっていました。
                </p>
                <p>そこで、不規則な形に切り取った段ボールの重心について尋ねてみました。</p>
                <p>「このへんかな？」「もうちょっと左かも？」</p>
                <p>意見が出尽くしたところで、糸とおもりを使った重心の見つけ方を説明し、実際にそこを指１本で支えて見せると、「おおーっ！！」と歓声。本当に良い反応をしてくれます(*'∀')。</p>
                <p>重心について理解を深めてもらった後は、いよいよお待ちかねの制作タイムです。今回つくるのは「コマ」。</p>
                <p>まずは、自由につくってもらい、そのコマの回る時間を計測。その後は、もっと長く回るコマにするべく改造タイムです。</p>
                <p>よく回るコマにするために気を付けるポイントは４つ。キーワードは「重心」「先端」「形」「重さ」です。床との摩擦や空気抵抗を極力抑えつつ、回転の軸がぶれないように......といったヒントをあげてみました。(実際はもっとかみ砕いて伝えましたが(;^_^A)
                </p>
                <div className="card-mokuji">
                    <img width="335" height="251" src={Img1} alt="" />
                </div>
                <p>「長く回るコマをつくりたい！」その一心で、真剣に説明をきいてくれました。子どもたちは夢中で楽しんでいるだけなのに、実は物理の学習が進んでいる――これがSTEMONの醍醐味です。</p>
                <p>そして、みんなが改良に改良を重ねたコマを持って、決勝戦です！</p>
                <p>今回は、先ほどのタイムとの合計で優勝者を決める形にしました。２回目ともなると、コマの回し方も上達してくるもので、そのおかげもありつつ、みんな大幅に記録更新(笑)。優勝者が決まった後も、最高記録を目指してトライし続けていました。お家の方がお迎えに来てくれてもまだまだ改良をし続ける子どもたち(;^ω^)。半ば強引にレッスン終了となりました。
                </p>
                <p>今後のレッスンも、子どもが本来持っている好奇心や意欲を最大限に引き出してあげることを意識しながら進めていきたいと思っています。</p>
            </div>
    </Main>
    
  );
}
export default Vol2;